import { render, staticRenderFns } from "./FreshdeskUserTicketList.vue?vue&type=template&id=6094c582&"
import script from "./FreshdeskUserTicketList.vue?vue&type=script&lang=js&"
export * from "./FreshdeskUserTicketList.vue?vue&type=script&lang=js&"
import style0 from "./FreshdeskUserTicketList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports